import ContributionGroupForm from './ContributionGroupForm';
import { Country, State } from '../../forms/address/types';
import type { Contribution } from './ContributionGroupForm';
import AnalyticsService from '../../analytics/AnalyticsService';
import { IViewItemAnalytics, IViewItemAnalyticsItem } from '../../analytics/types';

interface PageConfig {
  contributionTypes: Array<Contribution>;
  addedContributionId: string | null;
  addedContributionAmount: string | null;
  stateFilterData: { states: State[]; countries: Country[]; };
  viewItemAnalyticsMap: Record<string, IViewItemAnalytics>;
  ga4DatalayerItems?: IViewItemAnalyticsItem[];
}

window.tnew.page.initialize = ({
  contributionTypes, addedContributionId, addedContributionAmount, stateFilterData, viewItemAnalyticsMap, ga4DatalayerItems,
}: PageConfig) => {
  AnalyticsService.pushEcommerceItems(ga4DatalayerItems ?? []);

  const form = new ContributionGroupForm(contributionTypes, stateFilterData, addedContributionId, addedContributionAmount, viewItemAnalyticsMap);

  if (addedContributionId) {
    form.loadContribution(addedContributionId);
  }
};
